import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios/index';
import $ from 'jquery';
import React from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Link } from 'react-router-dom';
import * as constants from '../util/constants';
import Alert from './common/Alert';
import Modal from './common/Modal';
import Propertii from './common/Propertii';

import loginIcon from '../media/img/creditreporting/login.png';
import iconOne from '../media/img/creditreporting/one.png';
import shoppingCartIcon from '../media/img/creditreporting/shoppingcart.png';
import iconTwo from '../media/img/creditreporting/two.png';
import GoogleLoginCustom from './common/GoogleLoginCustom';

// Toggle between hide or show input password
const showPassword = () => {
  let passwordInput = $('[name="password"]');
  let passwordIconEyeSlash = $('[name="passwordIconEyeSlash"]');
  let passwordIconEye = $('[name="passwordIconEye"]');

  if (passwordInput.attr('type') === 'password') {
    passwordInput.attr('type', 'text');
    passwordIconEyeSlash.show();
    passwordIconEye.hide();
  } else {
    passwordInput.attr('type', 'password');
    passwordIconEyeSlash.hide();
    passwordIconEye.show();
  }
};

/**
 * Credit Reporting Promotional login page
 * This page is based on the original login component, updated to add promotional items for Credit reporting
 */

class LoginCreditReporting extends Propertii {
  /**
   * Initialize the component.
   *
   * @param props - The properties of the component.
   */
  constructor(props) {
    super(props);

    this.state = {
      type: '',
      username: '',
      password: '',
      validationList: [],
    };

    this.submitLogin = this.submitLogin.bind(this);
    this.submitOAuth = this.submitOAuth.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.searchBroadcastMessages = this.searchBroadcastMessages.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    $('[name="passwordIconEyeSlash"]').hide();
  }

  /**
   * Handle change events on fields.
   *
   * @param event - The event container.
   */
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /**
   * Handle validation if errors were returned from the server response. Map the errors to the appropriate state.
   *
   * @param error - The server error response.
   */
  handleValidation(error) {
    let fields = {};

    if (error.response.data.fieldErrors) {
      Object.entries(error.response.data.fieldErrors).forEach(([key, value]) => {
        fields[value.fieldName] = value.errorCode;
      });
    }

    // Handle account status validation errors
    const accountStatus = error.response.data.accountStatus;

    // Display login-specific errors if the error code returned is the generic system account status error
    if (error.response.data.errorCode === 'RM_ERROR_SYSTEM_ACCOUNT_STATUS') {
      this.setState({
        validationList: [
          {
            alert: {
              type: 'danger',
              message: error.response.data.message,
              code:
                'login.' +
                error.response.data.errorCode +
                (accountStatus ? '.' + accountStatus : ''),
            },
            fields,
          },
        ],
      });
      return;
    }

    if (error.response.data.errorCode === 'RM_ERROR_PASSWORD_EXPIRED') {
      $('#password-expired').modal('show');

      return;
    }

    if (error.response.data.errorCode === 'RM_ERROR_REDIRECT_MIGRATED') {
      const response = error.response.data;
      const message = JSON.parse(response.message);
      return this.props.history.push({
        pathname: `/onboarding/${message.userId}/customer`,
        state: {
          firstName: message.firstName || '',
          lastName: message.lastName || '',
          verificationCode: message.verificationCode || '',
        },
      });
    }

    this.setState({
      validationList: [
        {
          alert: {
            type: 'danger',
            message: error.response.data.message,
            code: error.response.data.errorCode,
          },
          fields,
        },
      ],
    });
  }

  /**
   * Handle logging in via OAuth. Parse the session owner from the returned access token and redirect the user to
   * their appropriate dashboard.
   *
   * @param response - The returned OAuth response.
   */
  submitOAuth(response) {
    if (
      encodeURIComponent(response.code) !== 'undefined' &&
      encodeURIComponent(`${window.location.protocol}//${window.location.hostname}`) !== 'undefined'
    ) {
      axios
        .get(
          `${
            constants.REACT_APP_HOST_API_URL
          }/authorizeoauth?accountType=TYPE_GOOGLE_OAUTH_ACCOUNT&authorizationCode=${encodeURIComponent(
            response.code
          )}&requestUri=${encodeURIComponent(
            `${window.location.protocol}//${window.location.hostname}`
          )}`
        )
        .then((response) => {
          // Store token data in local storage
          localStorage.setItem('token_type', response.data.token_type);
          localStorage.setItem('access_token', response.data.access_token);
          localStorage.setItem('expires_in', response.data.expires_in);
          localStorage.setItem('expires_at', Date.now() + response.data.expires_in * 1000);

          // Refresh the app state
          this.props.refreshAppState();

          let token = localStorage.getItem('access_token');
          let sessionRole;

          // Decipher the token
          if (token !== null) {
            let base64Url = token.split('.')[1];
            let base64 = base64Url.replace('-', '+').replace('_', '/');
            let userSession = JSON.parse(Buffer.from(base64, 'base64').toString('utf8'));

            sessionRole = JSON.parse(userSession.sessionRole);
            sessionStorage.setItem('session_role_id', sessionRole.id);
          }

          if (sessionRole && sessionRole.type === 'TYPE_CUSTOMER') {
            window.location.href = '/customer/dashboard?login=cr';
          } else {
            const pathname = localStorage.getItem('pathname');
            this.props.history.push(pathname || this.handleLoginRedirect(sessionRole));
            localStorage.removeItem('pathname');
          }
        })
        .catch((error) => {
          this.handleValidation(error);
        });
    } else {
      this.setState((prevState) => ({
        ...prevState,
        spinner: false,
        validationList: [
          {
            fields: {},
            alert: {
              type: 'danger',
              code: 'login.cookies.DISABLED',
            },
            values: {
              errorCause: 'Google Auth',
            },
          },
        ],
      }));
      window.scrollTo(0, 0);
    }
  }

  /**
   * Handle login form submission. If successful, store token information into the localStorage and update the entire
   * App by calling refreshAppState(). Afterward, redirect the user to their appropriate dashboard, depending on the
   * user's type and user's screening status, if applicable.
   *
   * @param event - The event container.
   */
  submitLogin(event) {
    event.preventDefault();

    axios
      .get(`${constants.REACT_APP_HOST_API_URL}/authorize`, {
        auth: {
          username: this.state.username,
          password: this.state.password,
        },
      })
      .then((response) => {
        // Store token data in local storage
        localStorage.setItem('token_type', response.data.token_type);
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('expires_in', response.data.expires_in);
        localStorage.setItem('expires_at', Date.now() + response.data.expires_in * 1000);

        // Fetch broadcast messages
        this.searchBroadcastMessages();

        // Refresh the app state
        this.props.refreshAppState();

        // Decipher the token
        let access_token = localStorage.getItem('access_token');
        let base64Url = access_token.split('.')[1];
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        let userSession = JSON.parse(Buffer.from(base64, 'base64').toString('utf8'));
        let sessionRole = JSON.parse(userSession.sessionRole);
        sessionStorage.setItem('session_role_id', sessionRole.id);

        if (sessionRole && sessionRole.type === 'TYPE_CUSTOMER') {
          window.location.href = '/customer/dashboard?login=cr';
        } else {
          const pathname = localStorage.getItem('pathname');
          this.props.history.push(pathname || this.handleLoginRedirect(sessionRole));
          localStorage.removeItem('pathname');
        }
      })
      .catch((error) => {
        this.handleValidation(error);
      });
  }

  /**
   * Reset the password for a system account.
   *
   * @param email - The email of the system account to reset the password for.
   */
  resetPassword(email) {
    axios
      .post(`${constants.REACT_APP_HOST_API_URL}/forgotpassword`, {
        username: this.state.username,
      })
      .then((response) => {
        this.setState({
          validationList: [
            {
              fields: {},
              alert: {
                type: 'primary',
                code: 'login.reset',
              },
            },
          ],
        });
      })
      .catch((error) => {
        this.handleValidation(error);
      });
  }

  /**
   * Fetch available broadcast messages for the user being logged in and store the data in the local storage.
   */
  searchBroadcastMessages() {
    axios
      .get(`${constants.REACT_APP_HOST_API_URL}/broadcast_message/active`, {
        headers: this.generateRequestHeaders(),
      })
      .then((response) => {
        localStorage.setItem('broadcast_messages', JSON.stringify(response.data));

        this.props.refreshAppState();
      })
      .catch((error) => {
        this.handleValidation(error);
      });
  }

  /**
   * Render the credit reporting login page
   *
   */
  render() {
    const { formatMessage } = this.props.intl;

    return (
      <div className='content-block'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-8'>
              <h5>
                <FormattedMessage id='static.login.credit-reporting.heading' />
              </h5>
            </div>
          </div>
          <div className='row mt-5'>
            <div className='col-md-8 mb-4'>
              <h2>
                <FormattedMessage
                  id='static.login.credit-reporting.tagline'
                  values={{
                    br: <br />,
                  }}
                />
              </h2>
              <p>
                <FormattedMessage id='static.login.credit-reporting.tagline.info' />
              </p>
              <ol>
                <li>
                  <FormattedMessage id='static.login.credit-reporting.tagline.info.sub1' />
                </li>
                <li>
                  <FormattedMessage id='static.login.credit-reporting.tagline.info.sub2' />
                </li>
                <li>
                  <FormattedMessage id='static.login.credit-reporting.tagline.info.sub3' />
                </li>
              </ol>
            </div>
            <div className='col-md-4'>
              <Alert validationList={this.state.validationList} />
              <h3 className='color-green'>
                <FormattedMessage id='static.login.credit-reporting.get-started' />
              </h3>
              <form onSubmit={this.submitLogin}>
                <div className='form-group row'>
                  <div className='col-md-12'>
                    <div className='input-group input-group-lg'>
                      <div className='input-group-prepend'>
                        <span className='input-group-text'>
                          <FontAwesomeIcon icon={['fas', 'user']} />
                        </span>
                      </div>
                      <input
                        name='username'
                        type='email'
                        placeholder={formatMessage({
                          id: 'field.email',
                        })}
                        autoFocus={true}
                        required
                        value={this.state['username']}
                        onChange={this.handleChange}
                        className={`form-control form-control-lg mb-0 rounded-right ${
                          this.state.validationList[0]
                            ? this.state.validationList[0].fields['username']
                              ? 'is-invalid'
                              : ''
                            : ''
                        }`}
                      />
                      {this.state.validationList[0] && (
                        <div className='invalid-feedback'>
                          <FormattedMessage
                            id={'danger.' + this.state.validationList[0].fields['username']}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className='form-group row'>
                  <div className='col-md-12'>
                    <div className='input-group input-group-lg'>
                      <div className='input-group-prepend'>
                        <span className='input-group-text'>
                          <FontAwesomeIcon icon={['fas', 'key']} />
                        </span>
                      </div>
                      <input
                        name='password'
                        type='password'
                        autoComplete='off'
                        required
                        placeholder={formatMessage({
                          id: 'field.password',
                        })}
                        value={this.state['password']}
                        onChange={this.handleChange}
                        className={`form-control form-control-lg mb-0 rounded-right ${
                          this.state.validationList[0]
                            ? this.state.validationList[0].fields['password']
                              ? 'is-invalid'
                              : ''
                            : ''
                        }`}
                      />
                      {this.state.validationList[0] && (
                        <div className='invalid-feedback'>
                          <FormattedMessage
                            id={'danger.' + this.state.validationList[0].fields['password']}
                          />
                        </div>
                      )}
                      <div
                        className='input-group-append'
                        onClick={() => {
                          showPassword();
                        }}
                      >
                        <span className='input-group-text eye-container'>
                          <FontAwesomeIcon icon={['fal', 'eye']} name='passwordIconEye' />
                          <FontAwesomeIcon
                            icon={['fal', 'eye-slash']}
                            name='passwordIconEyeSlash'
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col text-center'>
                    <div className='small mb-3'>
                      <Link to='/forgot-password'>
                        <FormattedMessage id='static.login.forgot' />
                      </Link>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col text-right'>
                    <button type='submit' className='btn btn-lg btn-primary btn-block mb-0'>
                      <FormattedMessage id='button.login' />
                    </button>
                  </div>
                </div>

                <div className='divider'>
                  <span className='small text-muted font-italic text-uppercase'>
                    <FormattedMessage id='label.or' />
                  </span>
                </div>

                <div className='row'>
                  <div className='col text-center d-flex flex-column align-items-center border border-primary p-2'>
                    <GoogleLoginCustom submitOAuth={this.submitOAuth}/>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className='row mt-5'>
            <div className='col-md-12 text-center'>
              <h2>
                <FormattedMessage id='static.login.credit-reporting.how-it-works' />
              </h2>
            </div>
          </div>
          <div className='row p-5'>
            <div
              className='col-md-5 mb-5'
              style={{ background: `url('${iconOne}') no-repeat right top scroll` }}
            >
              <img
                src={loginIcon}
                className='rounded img-fluid bg-secondary p-2'
                alt='loginIcon'
                title='loginIcon'
                width='42'
              />
              <h4>
                <FormattedMessage id='static.login.credit-reporting.how-it-works.step1.heading' />
              </h4>
              <p>
                <FormattedMessage id='static.login.credit-reporting.how-it-works.step1.info' />
              </p>
            </div>
            <div className='col-md-2'></div>
            <div
              className='col-md-5'
              style={{ background: `url('${iconTwo}') no-repeat right top scroll` }}
            >
              <img
                src={shoppingCartIcon}
                className='rounded img-fluid bg-secondary p-2'
                alt='shoppingCartIcon'
                title='shoppingCartIcon'
                width='40'
              />
              <h4>
                <FormattedMessage id='static.login.credit-reporting.how-it-works.step2.heading' />
              </h4>
              <p>
                <FormattedMessage id='static.login.credit-reporting.how-it-works.step2.info' />
              </p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 text-center'>
              <h2>
                <FormattedMessage id='static.login.credit-reporting.for-assistance' />
              </h2>
              <h5 className='mt-3'>
                <FormattedMessage id='static.login.credit-reporting.for-assistance-email' />
                &nbsp;<a href='mailto:help@let.us'>help@let.us</a>
              </h5>
              <h5>
                <FormattedMessage id='static.login.credit-reporting.for-assistance-phone' />
              </h5>
            </div>
          </div>
        </div>
        <Modal
          id='password-expired'
          theme='primary'
          iconType='fas'
          iconName='key'
          title='Password Expired'
          body='Your Letus account password has expired. Click the button below to receive an email with a link to reset your password.'
        >
          <button type='button' className='btn btn-outline-primary btn-lg' data-dismiss='modal'>
            <FormattedMessage id='button.close' />
          </button>
          <button
            onClick={() => {
              this.resetPassword();
            }}
            className='btn btn-primary btn-lg'
            data-dismiss='modal'
          >
            Reset My Password
          </button>
        </Modal>
      </div>
    );
  }
}

LoginCreditReporting.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(LoginCreditReporting);
